import get from 'lodash.get';

const getLastAppliedMigrationId = (state) => get(state, 'ws.site.lastAppliedMigrationId', null);

export default getLastAppliedMigrationId;
